import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';
import { LIST_VISIT_US } from '../../apiCalls/urls/visitUs';
import { GET_LIST } from '../../apiCalls/urls/common';
export const visitUsApi = createApi({
    baseQuery,
    tagTypes: ['visitUs'],
    reducerPath: 'visitUsApi',
    endpoints: (builder) => ({
        getVisitUsList: builder.query({
            query: (bodyData) => ({
                url: LIST_VISIT_US,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['visitUs'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetVisitUsListQuery,
    useGetListMutation
} = visitUsApi;